__turbopack_context__.v({
  "checkIcon": "BrowsingLevelInput-module-scss-module__yu1wsG__checkIcon",
  "compact": "BrowsingLevelInput-module-scss-module__yu1wsG__compact",
  "iconWrapper": "BrowsingLevelInput-module-scss-module__yu1wsG__iconWrapper",
  "label": "BrowsingLevelInput-module-scss-module__yu1wsG__label",
  "root": "BrowsingLevelInput-module-scss-module__yu1wsG__root",
});
